import s from "./basket.module.css";
import {useEffect, useState} from "react";
import del from "../../img/basketDelete.svg";
import {useDispatch, useSelector} from "react-redux";
import {calculateSum, deleteOrder, orderCounter, setOrder} from "../../store/OrderSlice";
import {readUserData, setUserInfo} from "../../firebase";


const BasketItem = ({item, indexOfItem}) => {
    const [productCount, setProductCount] = useState(item.count);
    const dispatch = useDispatch();
    const userId = useSelector(state => state.authUser.userId);

    useEffect(() => {
        dispatch(calculateSum(productCount * item.price));
    }, []);


    return (
        <ul>
            <li><img src={item.img} alt=""/></li>
            <li>{item.name}</li>
            <li className={s.counter}>{productCount}
                <div>
                    <button onClick={() => {
                        setProductCount(productCount + 1);
                        setUserInfo(userId, {
                            [`Order`]: {
                                [item.orderName]: {
                                    count: productCount + 1
                                }
                            }
                        });
                        dispatch(calculateSum(item.price));
                    }}>+
                    </button>
                    <button onClick={() => {
                        if (productCount > 1) {
                            setProductCount(productCount - 1);
                            setUserInfo(userId, {
                                [`Order`]: {
                                    [item.orderName]: {
                                        count: productCount - 1
                                    }
                                }
                            });
                            dispatch(calculateSum(-item.price));
                        }
                    }}>-
                    </button>
                </div>
                <img src={del} alt="" onClick={() => {
                    dispatch(deleteOrder(indexOfItem));
                    dispatch(calculateSum(-productCount * item.price));
                }}/>
            </li>
            <li>{item.price} грн</li>
            <li>{productCount * item.price} грн</li>
        </ul>

    )
}

export default BasketItem;